// @flow
import React from 'react';
import {Link} from 'react-router-dom';

import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import megaphone from '../../../../assets/img/megaphone-referral.svg';
type Props = {};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    borderRadius: '12px',
    backgroundColor: '#7B39FF',
    padding: theme.spacing(1, 2),
    margin: theme.spacing(1, 0, 0, 0),
  },
  containerReferral: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  navLink: {
    textDecoration: 'none',
  },
  text: {
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '16px',
  },
  arrow: {
    color: '#FFFFFF',
  },
}));

export default function ReferralInformation(props: Props) {
  const classes = useStyles();
  return (
    <Link to="/profile/referral" className={classes.navLink}>
      <div className={classes.root}>
        <div className={classes.containerReferral}>
          <img src={megaphone} alt="referral" />
          <Typography className={classes.text}>Refiere a un amigo</Typography>
          <ArrowForwardIcon className={classes.arrow} />
        </div>
      </div>
    </Link>
  );
}
